export default (ua) => {
  ua = (ua || navigator.userAgent).toLowerCase();
  // eslint-disable-next-line
  const match = ua.match(/android\s([0-9\.]+)/);
  return match ? parseFloat(match[1]) : false;
};
